import { BKJButton, BKJTextInput, Flex } from '@awais4123/fillify-design-library';
import { ChangeFunctionType } from '@awais4123/fillify-design-library/lib/common.types';
import { BKJSideModalFooter } from 'components/BKJSideModalFooter';
import { useFetchCommunitiesDataContext } from 'components/CustomFieldModal/Contexts/FetchCommunities.data.context';
import { useFetchCommunitiesCountDataContext } from 'components/CustomFieldModal/Contexts/FetchCommunitiesCount.data.context';
import {
  CUSTOM_FIELDS_MODAL_FACILITIES_EMPTY_SEARCH,
  SEARCH_FACILITY_INITIAL_STATE,
} from 'components/CustomFieldModal/CustomFieldModal.constants';
import { FacilitiesSelectionTable } from 'components/CustomFieldModal/Views/ApplyEditFacilitiesToCustomField/FacilitiesSelectionTable';
import {
  FacilitiesSelectionCountLabel,
  Heading,
  NoResultsFoundWrapper,
} from 'components/CustomFieldModal/CustomFieldModal.styled';
import { FC, Fragment, MouseEventHandler } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import { useApplyFacilitiesFormContext } from 'components/CustomFieldEditModal/contexts/ApplyFacilities.form.context';

export const EditFacilitiesView: FC = () => {
  const {
    data: fetchCommunities,
    values: fetchCommunitiesValues,
    onChange,
    isLoading,
  } = useFetchCommunitiesDataContext();
  const fetchCommunitiesCount = useFetchCommunitiesCountDataContext();
  const {
    values,
    handleApplyAllFacilitiesChange,
    handleApplyFacilitiesChange,
    isDisabled,
    onSubmit,
  } = useApplyFacilitiesFormContext();
  const { t } = useTranslation();

  return (
    <Fragment>
      <Flex flexDirection="column" gap="32px" padding="32px" flex="1">
        <Heading>{t('settings:SELECT_LOCATIONS_TO_APPLY')}:</Heading>
        <BKJTextInput
          onChange={onChange as ChangeFunctionType}
          name="byName"
          value={fetchCommunitiesValues?.byName}
          leftIconProps={{ iconName: 'Search' }}
          placeholder={t('settings:SEARCH_LOCATION')}
          rightIconProps={
            fetchCommunitiesValues?.byName === '' ? undefined : { iconName: 'CloseBold' }
          }
          onClick={() => onChange(SEARCH_FACILITY_INITIAL_STATE)}
        />
      </Flex>
      {!!fetchCommunities?.fetchCommunities.nodes?.length || isLoading ? (
        <FacilitiesSelectionTable
          values={values}
          handleApplyAllFacilitiesChange={handleApplyAllFacilitiesChange}
          handleApplyFacilitiesChange={handleApplyFacilitiesChange}
        />
      ) : (
        <NoResultsFoundWrapper alignItems="center" justifyContent="center">
          {t(CUSTOM_FIELDS_MODAL_FACILITIES_EMPTY_SEARCH)}
        </NoResultsFoundWrapper>
      )}
      <BKJSideModalFooter justifyContent="space-between">
        <FacilitiesSelectionCountLabel>
          {`${t('common:SELECTED')}: ${values.communityIds.length}/${fetchCommunitiesCount}`}
        </FacilitiesSelectionCountLabel>
        <BKJButton
          variant="PurpleSolid"
          width="180px"
          disabled={isDisabled}
          onClick={onSubmit as unknown as MouseEventHandler<HTMLButtonElement>}
        >
          {t('auth:APPLY')}
        </BKJButton>
      </BKJSideModalFooter>
    </Fragment>
  );
};
